const mixedFruitPulpData = {
  hero_section: {
    title: "Mixed Fruit Pulps & IQF Products",
    description: "Custom Blends • IQF Frozen Fruits • Frozen Vegetables",
    src: "videos/mixed-fruit-processing.webm",
  },
  description: {
    title: "Zenvia Mixed Fruit & IQF Collection",
    main_description:
      "Explore our diverse range of custom mixed fruit pulps, IQF (Individually Quick Frozen) fruits, and frozen vegetables. From mango dices and pineapple chunks to green peas and mixed vegetable packs.",
    segment_description:
      "Perfect for desserts, smoothies, beverages, institutional kitchens, and global retail chains.",
    variety_description:
      "Available in bulk packs and consumer-ready sizes to meet B2B and retail market demands.",
  },
  products: [
    {
      id: "1",
      name: "Mixed Fruit Pulp",
      image: "fs_passion_sc.webp",
      features: [
        "Custom fruit combinations",
        "Balanced flavor profiles",
        "Bulk & retail packs",
        "Perfect for beverages"
      ],
      meta: {
        weight: "Bulk & Retail Packs"
      }
    },
    {
      id: "2",
      name: "IQF Mango Dices/Slices",
      image: "fp_mango_sc.webp",
      features: [
        "Individually Quick Frozen",
        "Maintains texture & flavor",
        "Perfect for desserts",
        "Ready-to-use convenience"
      ],
      meta: {
        weight: "Bulk Packs"
      }
    },
    {
      id: "3",
      name: "IQF Pineapple Chunks",
      image: "fs_pineapple_sc.webp",
      features: [
        "Premium pineapple chunks",
        "Blast frozen freshness",
        "Ideal for smoothies",
        "Long shelf life"
      ],
      meta: {
        weight: "Bulk Packs"
      }
    },
    {
      id: "4",
      name: "Frozen Vegetables",
      image: "fs_coconut_sc.webp",
      features: [
        "Green peas, beans, carrots",
        "Mixed vegetable packs",
        "Institutional kitchen ready",
        "Global retail chain approved"
      ],
      meta: {
        weight: "Bulk & Retail Packs"
      }
    }
  ],

  text_section: {
    title: "Zenvia Mixed Products Excellence",
    description: "Our mixed fruit pulps and IQF products are carefully crafted at our facility using advanced blast freezing and processing techniques. With –20°C storage and cold chain excellence, we ensure consistent quality and freshness in every batch.",
  },
  
  feature_text_section: {
    title: "Perfect for Global Markets",
    subline: "From institutional kitchens to retail chains – versatile products for every need!",
    description:
      "Ideal for restaurants, cafes, institutional kitchens, global retail chains, and food service providers who demand convenience, quality, and reliable supply.",
  },
  
  feature_cards_info_card: [
    {
      id: 1,
      image: "beverage-applications.webp",
      title: "Beverage Applications",
      description:
        "Perfect for unique juice blends, smoothies, and tropical drink mixes with complex flavor profiles.",
    },
    {
      id: 2,
      image: "dessert-applications.webp",
      title: "Dessert Applications",
      description:
        "Ideal for ice creams, yogurts, cakes, and confectionery products requiring unique fruit combinations.",
    },
    {
      id: 3,
      image: "food-service-applications.webp",
      title: "Food Service",
      description:
        "Excellent for restaurants, cafes, and catering services looking for innovative fruit ingredients.",
    },
  ],
  
  overlay_card: [
    {
      id: 1,
      key: "Natural Processing",
      image: "natural-processing.webp",
      title: "Natural Processing",
      description:
        "No artificial preservatives, colors, or additives—just pure, natural fruit goodness",
    },
    {
      id: 2,
      key: "Quality Assurance",
      image: "quality-assurance.webp",
      title: "Quality Assurance",
      description:
        "Rigorous testing and quality control at every stage ensures premium standards",
    },
    {
      id: 3,
      key: "Consistent Supply",
      image: "consistent-supply.webp",
      title: "Consistent Supply",
      description:
        "Reliable production capacity and supply chain for your business needs",
    },
    {
      id: 4,
      key: "Versatile Applications",
      image: "versatile-applications.webp",
      title: "Versatile Applications",
      description:
        "Suitable for beverages, desserts, confectionery, and food service applications",
    },
  ],
  
  why_choose_section: {
    title: "Why Choose Our Mixed Fruit Pulp",
    description: "Discover the perfect blend of quality, consistency, and innovative flavors that make our mixed fruit pulps the preferred choice for food manufacturers worldwide.",
  },
};

export default mixedFruitPulpData;
